import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, unref as _unref } from "vue"

const _hoisted_1 = { class: "cp-expand__debt" }
const _hoisted_2 = {
  key: 0,
  class: "cp-expand__empty"
}
const _hoisted_3 = { class: "cp-expand__row-left" }
const _hoisted_4 = { class: "cp-expand__row-count" }
const _hoisted_5 = { class: "cp-expand__row-name" }
const _hoisted_6 = { style: { whiteSpace: 'nowrap' } }
const _hoisted_7 = { class: "cp-expand__row-right" }
const _hoisted_8 = { class: "cp-expand__debt" }

import { formatMoney } from "@/utils/format";
import { computed, ref } from "vue";
import ExpandListModal from "@/components/common/modal/ExpandListModal.vue";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import AppTooltip from "@/components/ui-kit/tooltip/AppTooltip.vue";
import AppResizableDropdown from "@/components/ui-kit/dropdown/AppResizableDropdown.vue";
import DetachCounterpartyConfirmDropdown from "@/components/main/client-block-page/dropdowns/DetachCounterpartyConfirmDropdown.vue";
import CounterpartyInfoModal from "@/components/main/client-block-page/modals/CounterpartyInfoModal.vue";
import { clientPageStore } from "@/store/client-page";


export default /*@__PURE__*/_defineComponent({
  __name: 'CounterpartiesExpandModal',
  setup(__props, { expose: __expose }) {

const clientStore = clientPageStore()

const client = computed(() => clientStore.openedClient)
const canEdit = computed(() => client.value?.CounterpartiesAccess === 2)

const filter = ref('')

const filteredCounterparties = computed(() => {
	const list = client.value?.Counterparties ?? []
	const q = filter.value.trim().toLowerCase()
	if (!q) {
		return list
	}
	return list.filter((cp: any) =>
		`${cp.Name ?? ''} ${cp.Instance1C ?? ''}`.toLowerCase().includes(q)
	)
})

const totalRevenue = computed(() => formatMoney(
	(client.value?.Counterparties ?? [])
		.reduce((acc: number, cur: any) => acc + (cur.Revenue ?? 0), 0)
))
const totalDebt = computed(() => formatMoney(
	(client.value?.Counterparties ?? [])
		.reduce((acc: number, cur: any) => acc + (cur.Debt ?? 0), 0)
))

const $modal = ref<InstanceType<typeof ExpandListModal> | null>(null)
const $infoModal = ref<InstanceType<typeof CounterpartyInfoModal> | null>(null)
const $cpDetach = ref<Record<number, any>>({})

const onOpen = () => {
	filter.value = ''
	$modal.value?.onOpen()
}
const onClose = () => $modal.value?.onClose()

const openInfo = (counterpartyId: number) => {
	$infoModal.value?.onOpen(counterpartyId, canEdit.value)
}

const onDetach = async (id: number) => {
	try {
		await clientStore.detachCounterparty(id)
	} catch (e) {
		console.error(e)
	} finally {
		$cpDetach.value[id]?.close()
	}
}

__expose({ onOpen, onClose })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ExpandListModal, {
      ref_key: "$modal",
      ref: $modal,
      title: _ctx.$t('client_counterparties_title'),
      placeholder: _ctx.$t('name_or_1c_instance'),
      filter: filter.value,
      "onUpdate:filter": _cache[0] || (_cache[0] = ($event: any) => (filter.value = $event))
    }, {
      summary: _withCtx(() => [
        _createTextVNode(" [" + _toDisplayString(_ctx.$t('client_revenue_label')) + " ", 1),
        _cache[1] || (_cache[1] = _createElementVNode("span", { style: { margin: '0 1px' } }, "/", -1)),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('client_debt_label')) + ": " + _toDisplayString(totalRevenue.value) + " ", 1),
        _cache[2] || (_cache[2] = _createElementVNode("span", { style: { margin: '0 1px' } }, "/", -1)),
        _createElementVNode("span", _hoisted_1, _toDisplayString(totalDebt.value), 1),
        _cache[3] || (_cache[3] = _createTextVNode("] "))
      ]),
      default: _withCtx(() => [
        (!filteredCounterparties.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$t('nothing_found')), 1))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredCounterparties.value, (cp, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: cp.Id,
            class: "cp-expand__row"
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(index + 1) + ".", 1),
              _createElementVNode("div", _hoisted_5, [
                _createTextVNode(_toDisplayString(cp.Name), 1),
                _createElementVNode("span", _hoisted_6, [
                  _cache[4] || (_cache[4] = _createTextVNode(" ")),
                  (cp.Instance1C)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode("[" + _toDisplayString(cp.Instance1C) + "] ", 1)
                      ], 64))
                    : _createCommentVNode("", true),
                  _createVNode(AppTooltip, {
                    text: _ctx.$t('info')
                  }, {
                    activator: _withCtx(() => [
                      _createVNode(AppIcon, {
                        class: "cp-expand__row-icon",
                        style: { marginTop: '-2px' },
                        name: "info-circle-outline",
                        width: "14px",
                        color: "#979797",
                        "hover-color": "#499259",
                        cursor: "pointer",
                        onClick: ($event: any) => (openInfo(cp.Id))
                      }, null, 8, ["onClick"])
                    ]),
                    _: 2
                  }, 1032, ["text"]),
                  (canEdit.value)
                    ? (_openBlock(), _createBlock(AppResizableDropdown, {
                        key: 1,
                        position: "right",
                        "close-by-click-outside": true,
                        ref_for: true,
                        ref: (el) => { if (el) $cpDetach.value[cp.Id] = el }
                      }, {
                        activator: _withCtx(() => [
                          _createVNode(AppTooltip, {
                            text: _ctx.$t('remove')
                          }, {
                            activator: _withCtx(() => [
                              _createVNode(AppIcon, {
                                class: "cp-expand__row-icon",
                                style: { marginTop: '-2px' },
                                name: "close-bold",
                                width: "12px",
                                color: "#D2D2D2",
                                "hover-color": "#BA4C4C",
                                cursor: "pointer"
                              })
                            ]),
                            _: 1
                          }, 8, ["text"])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(DetachCounterpartyConfirmDropdown, {
                            onCancel: ($event: any) => ($cpDetach.value[cp.Id]?.close()),
                            onConfirm: ($event: any) => (onDetach(cp.Id))
                          }, null, 8, ["onCancel", "onConfirm"])
                        ]),
                        _: 2
                      }, 1536))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createTextVNode(_toDisplayString(_unref(formatMoney)(cp.Revenue)), 1),
              _cache[5] || (_cache[5] = _createElementVNode("span", { style: { margin: '0 1px' } }, "/", -1)),
              _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(formatMoney)(cp.Debt)), 1)
            ])
          ]))
        }), 128))
      ]),
      _: 1
    }, 8, ["title", "placeholder", "filter"]),
    _createVNode(CounterpartyInfoModal, {
      ref_key: "$infoModal",
      ref: $infoModal
    }, null, 512)
  ], 64))
}
}

})